import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { FundTypeEnum, InventoryActionEnum } from '~utils/enums';

export default function* watchExportInventoryReceivedListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldExportInventoryReceivedListingAttempt', handleExportInventoryReceivedListing, api);
}

function* handleExportInventoryReceivedListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { filters: { branchCode, productId, serialNo, fundType } } = reduxState.gold.goldInventoryReport.inventoryReceived;

    const response = yield* call([api, api.getInventoryTransfers], {
        authToken,
        index: 0,
        action: InventoryActionEnum.TransferTo,
        branchCode: branchCode || undefined,
        productId: productId || undefined,
        serialNo: serialNo || undefined,
        fundType: FundTypeEnum[fundType as keyof typeof FundTypeEnum] || undefined,

    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldExportInventoryReceivedListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldExportInventoryReceivedListingSuccess(response.data.data));
    }
}
